<template>
  <div class="client-container">
    <div>
      <a-row>
        <a-col :span="2">
          <bread-crumb />
        </a-col>
        <a-col :span="22">
          <table-search
            @onSearch="onSearch"
            @onChangeStatus="onChangeStatus"
            @onChangeActiva="onChangeActiva"
            @onChangeRank="onChangeRank"
            @onChangeSection="onChangeSection"
            @editAndAdd="editAndAdd"
          />
        </a-col>
      </a-row>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="doctor_task_count"
          slot-scope="text, record"
        >
          <a @click="handleList(record)">{{ record. doctor_task_count }}</a>
        </template>
        <template
          slot="promoters_count"
          slot-scope="text, record"
        >
          <a @click="handlePromoters(record)">{{ record.promoters_count }}</a>
        </template>
        <template

          slot="operation"
          slot-scope="text, record"
        >
          <a
            v-if="record.check_status===2"
            href="javascript:;"
            @click="() => handleApprove(record)"
          >认证</a>
          <a-divider
            v-if="record.check_status===2"
            type="vertical"
          />
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.user_status===1?'禁用':'启用'"
            :alert-title="record.user_status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
        </template>
      </a-table>
    </div>
    <add-edit-modal
      ref="formRef"
      :title="title"
      :visible="visible"
      :type-id="typeId"
      :btn-is-loading="btnIsLoading"
      @onCancel="onCancel"
      @handleSubmit="onSubmit"
    />
    <promoter-list
      :data="promoteData"
      :visible="visiblePromote"
      @onCancel="onCancelPromote"
    />
    <promoters-list
      :data="promotersData"
      :visible="visiblePromoters"
      @onCancel="onCancelPromoters"
    />
    <approve-modal
      ref="approveRef"
      :data="approveData"
      :btn-is-loading="btnIsLoadingApprove"
      :visible="visibleApprove"
      @onCancel="onCancelApprove"
      @handleSubmit="onSubmitApprove"
    />
  </div>
</template>
<script>
import {
  columns,
} from './data/index';
import TableSearch from './components/search';
import addEditModal from './modal/index';
import PromoterList from './modal/promoterList.vue';
import PromotersList from './modal/promoters.vue';
import ApproveModal from './modal/approveModal.vue';
export default {
  components: {TableSearch, addEditModal, PromoterList, ApproveModal, PromotersList},
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      typeId: '',
      id: '',
      promoteData: [],
      visiblePromote: false,
      visibleApprove: false,
      btnIsLoadingApprove: false,
      approveData: {},
      check_status: '',
      doctor_status: '',
      professional: '',
      department: '',
      promotersData: [],
      visiblePromoters: false,

    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({page: this.current, pageSize: this.pageSize,
      keyword: this.keyword, check_status: this.check_status,
      doctor_status: this.doctor_status, department: this.department,
      professional: this.professional,
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/doctor/adminGetList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            user_status: item.user_status,
            user_realname: item.user_realname,
            mobile: item.mobile,
            hospital: item.hospital,
            department_name: item.department_name,
            professional_name: item.professional_name,
            doctor_status: item.doctor_status,
            check_status: item.check_status,
            doctor_task_count: item.doctor_task_count,
            promoters_count: item.promoters_count,
            qualification_type: item.qualification_type,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
      });
    },
    // 改变状态
    onChangeStatus(value){
      this.current=1;
      this.check_status=value;
      console.log('onChangeStatus -> value', value);
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
      });
    },
    // 改变激活状态
    onChangeActiva(value){
      this.current=1;
      this.doctor_status=value;
      console.log('onChangeActiva -> value', value);
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
      });
    },
    // 选择科室
    onChangeSection(value){
      this.current=1;
      this.department=value;
      console.log('onChangeActiva -> value', value);
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
      });
    },

    // 选择职称
    onChangeRank(value){
      this.current=1;
      console.log('onChangeActiva -> value', value);
      this.professional=value;
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
      });
    },
    // 编辑或新增
    async editAndAdd(record) {
      console.log('editAndAdd -> record', record);
      this.visible=true;
      if(!record){
        this.title='新增医生';
        this.id='';
        this.$nextTick(()=>{
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });

      }else{
        this.title='编辑医生';
        this.id=record.id;
        let result=await this.$http.post('/promoter/getPromotersList', {id: record.id});
        if(result.data.status===1){
          let data={
            hospital_id: record.data.hospital_id,
            user_realname: record.data.user_realname,
            promoters: result.data.data.data_list.map((item)=>{return item.promoter_id;}),
            sex: record.data.sex,
            provinceCity: {province: record.data.province_id, city: record.data.city_id},
            mobile: record.data.mobile,
            address: record.data.address,
            speciality: record.data.speciality,
            department_id: String(record.data.department_id),
            professional_id: record.data.professional_id,
          };
          this.$nextTick(()=>{
            this.$refs.formRef.$refs.basicForm.form.resetFields();
            this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
          });
        }

      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('onSubmit -> values', values);
          if (!err) {
            values.province_id=values.provinceCity?values.provinceCity.province:'';
            values.city_id=values.provinceCity?values.provinceCity.city:'';
            values.path=`0,${values.provinceCity?values.provinceCity.province:''},${values.provinceCity?values.provinceCity.city:''}`;
            values.promoters=values.promoters.join();
            this.btnIsLoading=true;
            let result=await this.$http.post('/doctor/update', {type: this.type, id: this.id, ...values});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData({page: this.current, pageSize: this.pageSize,
                keyword: this.keyword, check_status: this.check_status,
                doctor_status: this.doctor_status, department: this.department,
                professional: this.professional,
              });
              this.visible = false;
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 查看关联推广数量
    async handleList(record){
      this.visiblePromote=true;
      let result=await this.$http.post('/task/doctorTask', {doctor_id: record.id, page: 1, pageSize: 100});
      if(result.data.status===1){
        this.promoteData=result.data.data.data_list;
        console.log('handleList -> this.promoteData', this.promoteData);
      }
    },
    // 关闭查看关联推广数量
    onCancelPromote(){
      this.visiblePromote=false;
    },
    // 查看关联推广员
    async handlePromoters(record){
      this.visiblePromoters=true;
      let result=await this.$http.post('/promoter/getPromotersList', {id: record.id, page: 1, pageSize: 10});
      if(result.data.status===1){
        this.promotersData=result.data.data.data_list;
      }
    },
    // 关闭查看关联推广员
    onCancelPromoters(){
      this.visiblePromoters=false;
    },
    // 查看认证
    handleApprove(record){
      this.id=record.id;
      this.approveData=record;
      if(record.data.sex===0){
        this.approveData.sex='保密';
      }
      if(record.data.sex===1){
        this.approveData.sex='男';
      }
      if(record.data.sex===2){
        this.approveData.sex='女';
      }
      this.approveData.qualification_type=record.data.qualification_type;
      this.approveData.qualifications_url=record.data.qualifications_url;
      this.approveData.qualifications_two_url=record.data.qualifications_two_url;
      this.visibleApprove=true;
    },
    // 确认认证
    async onSubmitApprove(){
      this.$refs.approveRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoadingApprove=true;
            let result=await this.$http.post('/doctor/chackStatus', {id: this.id, ...values});
            this.btnIsLoadingApprove=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData({page: this.current, pageSize: this.pageSize,
                keyword: this.keyword, check_status: this.check_status,
                doctor_status: this.doctor_status, department: this.department,
                professional: this.professional,
              });
              this.visibleApprove=false;
            }
          }});

    },
    // 取消认证
    onCancelApprove(){
      this.visibleApprove=false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('doctor/canChange', {id: record.id, user_status: record.user_status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({page: this.current, pageSize: this.pageSize,
          keyword: this.keyword, check_status: this.check_status,
          doctor_status: this.doctor_status, department: this.department,
          professional: this.professional,
        });

      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
      });

    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
